import { render, staticRenderFns } from "./ContestSummaryAgencyEvaluationAuthors.vue?vue&type=template&id=5a576bd4&scoped=true&"
import script from "./ContestSummaryAgencyEvaluationAuthors.vue?vue&type=script&lang=js&"
export * from "./ContestSummaryAgencyEvaluationAuthors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a576bd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListGroup } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileActionText } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VExpandTransition,VFlex,VIcon,VLayout,VList,VListGroup,VListTile,VListTileAction,VListTileActionText,VListTileContent,VListTileSubTitle,VListTileTitle,VSubheader,VToolbar,VToolbarTitle})
